import { splitUrl } from './splitUrl';

interface Args {
  url: string;
  queryString: string;
}

/** Keeps a query string the url already carries, and stays before the hash. */
export const appendQueryString = ({ url, queryString }: Args): string => {
  if (!queryString) return url;

  const { path, query, hash } = splitUrl(url);
  const merged = [query, queryString].filter(Boolean).join('&');

  return `${path}?${merged}${hash}`;
};
